import MDivider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const DetailsContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "24px",
  padding: "32px 0 32px 24px",
});

export const LeftContentContainer = styled("div")(() => ({
  maxWidth: "282px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));

export const RightContentContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  width: "100%",
}));

export const RightContentWrapper = styled(Grid)(() => ({
  maxWidth: "100% !important",
}));

export const DatesContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  padding: "0 24px 32px",
});

export const ItemWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  gap: "24px",
  width: "100%",
}));

export const InputWrapper = styled("div")(() => ({
  maxWidth: "315px",
  width: "100%",
}));

export const BranchOption = styled("li")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  padding: "0 !important",
}));

export const BranchOptionText = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const FileInputBox = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: "100%",
  height: 250,
  border: `1px dashed ${colors.gray300}`,
  borderRadius: "4px",
  position: "relative",
  "& span:nth-child(1)": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.1px",
  },
  "& label > span:nth-child(2)": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20x",
    letterSpacing: "0.25px",
  },
  "& label > span:nth-child(3)": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20x",
    letterSpacing: "0.25px",
  },
}));

export const LabelInputBox = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: "100%",
  cursor: "pointer",
}));

export const IconsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px 0",
}));

export const Title = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const IconBoxContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "stretch",
  gap: "12px",
  flexWrap: "wrap",
  position: "relative",
  maxHeight: "132px",
  width: "100%",
}));

type IconBoxProps = {
  selected: boolean;
  disabled?: boolean;
};

export const IconBox = styled("div", {
  shouldForwardProp: (props) => props !== "selected" && props !== "disabled",
})(({ selected, disabled = false }: IconBoxProps) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: `${selected ? 2 : 1}px solid ${selected ? colors.brandBlue500 : colors.gray200}`,
  borderRadius: "8px",
  height: "60px",
  width: "60px",
  backgroundColor: colors.white,
  cursor: "pointer",
  position: "relative",
  pointerEvents: disabled ? "none" : undefined,
}));

export const CheckedBox = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "20px",
  width: "20px",
  borderRadius: "20px",
  padding: "4px",
  position: "absolute",
  right: "-8px",
  top: "-8px",
  backgroundColor: colors.success500,
}));

export const Divider = styled(MDivider)(() => ({
  marginTop: "32px",
  marginBottom: "32px",
  position: "relative",
}));
